module.exports = __webpack_public_path__ + "img/Unassign.d69d67f0.png";